import { Button, Divider, Stack } from "@mui/material";
import { CourseDto, CourseEmployeeDto, CourseType } from "../../../api/psc";
import {
    CardInformation,
    DialogContainer,
    DialogHeader,
} from "../../../components/exports";
import KeyValueText from "../../../components/shared/KeyValueText";

export default function CourseRegistrationCredentials(props: {
    courseEmployee: CourseEmployeeDto;
    course: CourseDto;
}) {
    return (
        <DialogContainer>
            <DialogHeader title="اطلاعات ورود به دوره آموزشی" />

            {props.course.type === CourseType.ONLINE && (
                <Stack spacing={2} sx={{ p: 2 }}>
                    <CardInformation
                        title="نام کاربری"
                        value={props.courseEmployee.employee.mobileNumber}
                    />
                    <CardInformation
                        title="رمز عبور"
                        value={props.courseEmployee.password}
                    />

                    <Divider />

                    <a href={props.course.roomUrl} target="_blank">
                        <Button fullWidth variant="contained">
                            لینک ورود به کلاس آموزشی
                        </Button>
                    </a>
                </Stack>
            )}

            {props.course.type === CourseType.IN_PERSON && (
                <Stack spacing={2} sx={{ p: 2 }}>
                    <KeyValueText title="آدرس" value={props.course.location} />
                    <KeyValueText
                        title="تاریخ"
                        value={props.course.humanReadableDate}
                    />
                </Stack>
            )}
        </DialogContainer>
    );
}
